import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { BoardMotif } from './BoardMotif';
const coverBands = ['bg-sage', 'bg-teal', 'bg-terra', 'bg-ochre', 'bg-sage-mid'];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="sage-ground w-full" data-id="element-32" data-mp="auth18udz3x1">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-33" data-mp="fsv7ieu565ij">
        <div className="text-center" data-id="element-34" data-mp="1tvl7du3q2pj">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-ochre" data-id="element-35" data-mp="1stww7o2rjpv">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="chalk-underline on-dark mt-3 font-display text-[28px] text-cream sm:text-5xl" data-id="element-36" data-mp="3o1lfsst9nnjz">
            Five bonuses to use it <em className="text-ochre-soft" data-id="element-37" data-mp="3t2j6xuw97rxm">this week</em>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-cream/75" data-id="element-38" data-mp="1marurq0iee4l">
            The volumes give you the experiments. These five get you offering
            them before your next session — so nothing sits unopened.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-39" data-mp="3dfleza6up43j">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`clip-corner flex flex-col overflow-hidden rounded-2xl border border-sage-line bg-sage-deep/70 ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-40" data-mp="3r6i76zwv7ja2" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-square w-full border-b border-sage-line object-cover" data-id="element-41" data-mp="2uik5pd69khts" /> : <div className="relative flex aspect-[16/9] w-full flex-col justify-end overflow-hidden border-b border-sage-line bg-cream p-5 text-ink" data-id="element-42" data-mp="ir6rzw41zc7s">
                  <div className={`absolute inset-x-0 top-0 h-1.5 ${coverBands[i % coverBands.length]}`} data-id="element-43" data-mp="3cin0ezw5b8ce" />
                  <BoardMotif className="pointer-events-none absolute -right-6 -top-4 h-40 w-40 text-teal/25" data-id="element-44" data-mp="3hk3zcpv2kkqc" />
                  <span className="absolute left-5 top-5 rounded-full bg-sage px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-cream" data-id="element-45" data-mp="3lhrzc7bmd3p3">
                    Bonus {bonus.number}
                  </span>
                  <span className="relative max-w-[85%] font-display text-[22px] leading-tight text-sage" data-id="element-46" data-mp="2xtqtx79qm3dw">
                    {bonus.title}
                  </span>
                  <span className="relative mt-2 flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-terra-deep" data-id="element-47" data-mp="32rs9hi7yfkkm">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="2a4z950yh8nb5" />
                    {bonus.meta}
                  </span>
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-49" data-mp="2f164jzt8ygeu">
                <div className="flex flex-wrap items-center gap-2" data-id="element-50" data-mp="27k9jr2l07qbt">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-cream/60" data-id="element-51" data-mp="22kwy2l5vcpat">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-ochre px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-ink" data-id="element-52" data-mp="1xk0njor0i4wf">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-cream" data-id="element-53" data-mp="1on8fjjz9xu8x">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-cream/75" data-id="element-54" data-mp="1ev2ms81778so">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}